<template>
    <div>

        <table v-if="data">
          <thead>
            <tr>
                <td>
<!--                  <div class="header-space">&nbsp;</div>-->
                  <div class="header-space1"></div>
                </td>
            </tr>
          </thead>

            <tbody>
            <tr>
              <td>
                <div class="content">
                  <div class="col-sm-11">
                      <div class="form-font p-md-0 offset-sm-1">
                          <div class="p-md-0 ">
                              <b-col cols="12" offset="0" class="">
                                    <b-row>
  
                                      <!--Insurer-->
  
                                      <b-col md="3" sm="12" class="description-top pt-2   nino-mtavruli " style="font-size:17px">პოლისის ნომერი</b-col>
                                      <b-col md="9" sm="12" class="p-2" style="background-color: #E0E0E0">
                                          <div class="text-center">
                                              <div class="pol-number">{{data.policyInfo[0].policyInsuranceProduct}}</div>
                                          </div>
                                      </b-col>
                                      <b-col md="12" sm="12" class="p-2 content-header mt-2">
                                          <div class="col-md-9 col-sm-12 offset-md-3 text-center nino-mtavruli"> მზღვეველი</div>
                                      </b-col>
                                      <b-col md="3" sm="12" class="description p-2  pl-3">დასახელება</b-col>
                                      <b-col md="9" sm="12" class="value-background p-2 ">
                                          <div class="text-center pl-3">
                                              <div>სს "არდი დაზღვევა"</div>
                                          </div>
                                      </b-col>
                                      <b-col md="3" sm="12" class="description p-2  pl-3">ს.კ</b-col>
                                      <b-col md="9" sm="12" class="value-background p-2 ">
                                          <div class="text-center">
  
                                              <div>ს|კ: {{data.policyInfo[0].compsoccart}}</div>
                                          </div>
                                      </b-col>
  
                                      <b-col md="12" sm="12" class="mt-2 p-2 content-header ">
                                          <div class="col-md-9 col-sm-12 offset-md-3 text-center nino-mtavruli">დამზღვევი</div>
                                      </b-col>
                                      <b-col md="3" sm="12" class="description p-2  pl-3">
                                          სახელი გვარი | სახელწოდება
                                      </b-col>
                                      <b-col md="9" sm="12" class="value-background p-2  ">
                                          <div class="text-center">{{data.policyInfo[0].customerName}}</div>
                                      </b-col>
                                      <b-col md="3" sm="12" class="description p-2  pl-3">მისამართი</b-col>
                                      <b-col md="9" sm="12" class="value-background p-2  ">
                                          <div class="text-center">{{data.policyInfo[0].customerRegistrationAddress}}</div>
                                      </b-col>
                                      <b-col md="3" sm="12" class="description p-2  pl-3">პირადი ნომერი | ს.კ</b-col>
                                      <b-col md="9" sm="12" class="value-background p-2  ">
                                          <div class="text-center">{{data.policyInfo[0].customerSocCard}}</div>
                                      </b-col>
                                      <b-col md="3" sm="12" class="description p-2  pl-3">მობილური | ტელეფონი</b-col>
                                      <b-col md="9" sm="12" class="value-background p-2  ">
                                          <div class="text-center">{{data.policyInfo[0].customerPhoneNumber}}</div>
                                      </b-col>
                                      <template v-for="(item,index) in data.objectInfo" v-if="item.ID == 1">
                                          <b-col md="12" sm="12" class="mt-2 p-2 content-header ">
                                              <div class="col-md-9 col-sm-12 offset-md-3 text-center nino-mtavruli">დაზღვეული {{ index +1}}  |  მსესხებელი {{ index +1}}</div>
                                          </b-col>
                                          <b-col md="3" sm="12" class="description p-2  pl-3">
                                              სახელი გვარი | სახელწოდება
                                          </b-col>
                                          <b-col md="9" sm="12" class="value-background p-2  ">
                                              <div class="text-center">{{item.Name}}</div>
                                          </b-col>
                                          <b-col md="3" sm="12" class="description p-2  pl-3">მისამართი</b-col>
                                          <b-col md="9" sm="12" class="value-background p-2  ">
                                              <div class="text-center">{{item.Saddress}}</div>
                                          </b-col>
                                          <b-col md="3" sm="12" class="description p-2  pl-3">პირადი ნომერი | ს.კ</b-col>
                                          <b-col md="9" sm="12" class="value-background p-2  ">
                                              <div class="text-center">{{item.Soccart}}</div>
                                          </b-col>
                                          <b-col md="3" sm="12" class="description p-2  pl-3">მობილური | ტელეფონი</b-col>
                                          <b-col md="9" sm="12" class="value-background p-2  ">
                                              <div class="text-center">{{item.Phone}}</div>
                                          </b-col>
                                      </template>

                                    </b-row>
                                    <b-row>
                                    
  
                                      <b-col md="12" sm="12" class="description p-2 mt-2 pl-3">
                                          და აგრეთვე ყველა ის ფიზიკური და/ან იურიდიული პირი და/ან პირთა გაერთიანება, რომლებმაც გააფორმეს გენერალური და/ან საკრედიტო
                                          ხელშეკრულება სს პროკრედიტ ბანკთან წინამდებარე პოლისში მითითებული დაზღვევის ობიექტის უზრუნველყოფით
                                      </b-col>
  
                                      <b-col md="12" sm="12" class="mt-2 p-2 content-header ">
                                          <div class="col-md-9 col-sm-12 offset-md-3 text-center nino-mtavruli">მოსარგებლე</div>
                                      </b-col>
                                      <b-col md="3" sm="12" class="description p-2  pl-3">
                                          სახელი გვარი | სახელწოდება
                                      </b-col>
                                      <b-col md="9" sm="12" class="value-background p-2  ">
                                          <div class="text-center">{{data.policyInfo[0].customerName}}</div>
                                      </b-col>
                                      <b-col md="3" sm="12" class="description p-2  pl-3">მისამართი</b-col>
                                      <b-col md="9" sm="12" class="value-background p-2  ">
                                          <div class="text-center">{{data.policyInfo[0].customerRegistrationAddress}}</div>
                                      </b-col>
                                      <b-col md="3" sm="12" class="description p-2  pl-3">პირადი ნომერი | ს.კ</b-col>
                                      <b-col md="9" sm="12" class="value-background p-2  ">
                                          <div class="text-center">{{data.policyInfo[0].customerSocCard}}</div>
                                      </b-col>
                                      <b-col md="3" sm="12" class="description p-2  pl-3">მობილური</b-col>
                                      <b-col md="9" sm="12" class="value-background p-2  ">
                                          <div class="text-center">{{data.policyInfo[0].customerPhoneNumber}}</div>
                                      </b-col>

                                    </b-row>
                                    <b-row>
  
                                      <b-col md="12" sm="12" class="mt-2 p-2 content-header ">
                                          <div class="col-md-9 col-sm-12 offset-md-3 text-center nino-mtavruli">დაზღვევის ობიექტ(ებ)ი</div>
                                      </b-col>
  
  
                                      <b-col md="12" sm="12" class="mt-2 p-2 content-header " v-if="data.machinery[0].ProductID == 1">
                                          <div class="col-md-9 col-sm-12 offset-md-3 text-center nino-mtavruli">{{data.machinery[0].Product}}</div>
                                      </b-col>
                                      <b-col md="12" sm="12" class="mt-2 p-2 content-header " v-if="data.machinery[0].ProductID == 2">
                                          <div class="col-md-9 col-sm-12 offset-md-3 text-center nino-mtavruli">{{data.machinery[0].Product}}</div>
                                      </b-col>
                                      <b-col md="12" sm="12" class="mt-2 p-2 content-header " v-if="data.machinery[0].ProductID == 3">
                                          <div class="col-md-9 col-sm-12 offset-md-3 text-center nino-mtavruli">{{data.machinery[0].Product}}</div>
                                      </b-col>
  
                                      <b-col md="3" sm="12" class="description p-2  pl-3">სახე</b-col>
                                      <b-col md="9" sm="12" class="value-background p-2  ">
                                          <div class="text-center">{{data.machinery[0].ObjectType}}</div>
                                      </b-col>
                                      <b-col md="3" sm="12" class="description p-2  pl-3">მისამართი</b-col>
                                      <b-col md="9" sm="12" class="value-background p-2  ">
                                          <div class="text-center">{{data.machinery[0].ObjectAddress}}</div>
                                      </b-col>
                                      <template v-if="data.machinery[0].ProductID == 1">
                                          <b-col md="3" sm="12" class="description p-2  pl-3">საკადასტრო კოდი</b-col>
                                          <b-col md="9" sm="12" class="value-background p-2  ">
                                              <div class="text-center">{{data.machinery[0].CadastralCode}}</div>
                                          </b-col>
                                          <b-col md="3" sm="12" class="description p-2  pl-3">მფლობელობის სახე</b-col>
                                          <b-col md="9" sm="12" class="value-background p-2  ">
                                              <div class="text-center">{{data.machinery[0].propertykind}}</div>
                                          </b-col>
                                      </template>
  
                                      <b-col md="3" sm="12" class="description p-2  pl-3">ჯამური საბაზრო ღირებულება</b-col>
                                      <b-col md="9" sm="12" class="value-background p-2  ">
                                          <div class="text-center">{{data.machinery[0].PropAmnt}}</div>
                                      </b-col>
                                      <b-col md="3" sm="12" class="description p-2  pl-3">ჯამური სადაზღვევო ღირებულება</b-col>
                                      <b-col md="9" sm="12" class="value-background p-2  ">
                                          <div class="text-center">{{data.machinery[0].SumPropAmnt}}</div>
                                      </b-col>
                                    </b-row>
                                    <b-row>
                                      <b-col md="12" sm="12" class="description p-3 mt-2">
                                          დაზღვეული ობიექტის სხვა მონაცემები განისაზღვრება დამზღვევის მიერ შევსებული განაცხად-ანკეტით
                                      </b-col>
  
  
                                      <b-col md="12" sm="12" class="mt-2 p-2 content-header1 ">
                                          <div class="col-md-9 col-sm-12 nino-mtavruli pl-2">დაზღვევის ტერიტორია</div>
                                      </b-col>
                                      <b-col md="12" sm="12" class=" p-2 value-background pl-3">
                                          <div>ობიექტის ადგილმდებარეობის მიხედვით</div>
                                      </b-col>
                                   </b-row>
                                    <b-row>
  
                                      <div class="col-12   mt-2 p-0  border-green">
  
                                          <div class="d-flex p-2 content-header1">
                                              <div class="col-6 nino-mtavruli pl-2"> სადაზღვევო რისკები (ALL RISKS)</div>
                                              <div class="col-3 text-center nino-mtavruli">სტატუსი </div>
                                              <div class="col-3 text-center nino-mtavruli">ფრანშიზა</div>
                                          </div>
                                          <div class="col-md-12 row m-0 p-0" style="font-size: 14px; ">
                                              <template v-for="item in data.risks">
                                                  <div class="col-6 border-bottom-mn border-right-mn">{{item.Riskname}}</div>
                                                  <div class="col-3 border-bottom-mn border-right-mn text-center">{{item.RiskState}}</div>
                                                  <div class="col-3 border-bottom-mn text-center">{{item.Noret}}</div>
                                              </template>
                                          </div>
  
                                      </div>
                                   </b-row>
                                    <b-row>
                                      <div class="mt-2 col-md-12 col-sm-12 ">
                                          <b-row>
                                              <b-col class="row">
                                                  <div class="col-md-6 description p-2 pl-3">წლიური პრემია</div>
                                                  <div class="col-md-6 p-2 border-mn">{{data.policyInfo[0].insurancePremiums}}</div>
                                              </b-col>
                                              <b-col class="row">
                                                  <div class="col-md-6 description p-2 pl-3">გადახდის ჯერადობა</div>
                                                  <div class="nino-mtavruli col-md-6  p-2 border-mn">{{data.policyInfo[0].payCount}}</div>
                                              </b-col>
  
                                          </b-row>
                                      </div>
                                     </b-row>
                                    <b-row>
                                      <b-col class="col-12 mt-2  description  bo mt-2 nino-mtavruli p-2 pl-3">
                                          გადახდის გრაფიკი
                                      </b-col>
  
                                      <div class="col-12 mt-2 m-0 d-flex justify-content-between">
                                          <div class="payment-block row p-0  border-green mr-4">
                                              <div class="col-6 border-value payment-title nino-mtavruli border-bottom-mn border-right-mn" style="background-color: #E0E0E0">
                                                  თარიღი
                                              </div>
                                              <div class="col-6 border-value payment-title nino-mtavruli border-bottom-mn" style="background-color: #E0E0E0">
                                                  თანხა
                                              </div>
                                              <template v-for="payment in data.policyInfo[0].propayment.slice(0, Math.round( data.policyInfo[0].propayment.length/2))">
                                                  
                                                   <div class="col-6 border-bottom-mn border-right-mn">
                                                      {{ payment.payDate }}
                                                  </div>
                                                  <div class="col-6 border-bottom-mn">
                                                      {{ payment.payment }}
                                                  </div>
                                              </template>
                                          </div>
  
                                          <div class="payment-block row p-0 border-green" v-if="data.policyInfo[0].propayment.length>=2">
                                              <div class="col-6  border-value payment-title nino-mtavruli border-bottom-mn border-right-mn" style="background-color: #E0E0E0">
                                                  თარიღი
                                              </div>
                                              <div class="col-6  border-value payment-title nino-mtavruli border-bottom-mn" style="background-color: #E0E0E0">
                                                  თანხა
                                              </div>
                                              <template v-for="payment in data.policyInfo[0].propayment.slice(Math.round(data.policyInfo[0].propayment.length/2), data.policyInfo[0].propayment.length)">
                                                  <div class="col-6 border-bottom-mn border-right-mn">
                                                      {{ payment.payDate }}
                                                  </div>
                                                  <div class="col-6 border-bottom-mn ">
                                                      {{ payment.payment }}
                                                  </div>
                                              </template>
                                          </div>
  
                                      </div>
  
                                    </b-row>
                                    <b-row>
                                      <b-col md="12" sm="12" class="mt-2 p-2 content-header1 ">
                                          <div class="col-md-9 col-sm-12 nino-mtavruli pl-2">სადაზღვევო პერიოდი</div>
                                      </b-col>
                                      <div class="d-flex col-12 p-0">
                                          <b-col md="3" sm="12" class=" p-2 value-background-rb" style="background-color: #E0E0E0">
                                              <div class="nino-mtavruli pl-2">დან</div>
                                          </b-col>
                                          <b-col md="3" sm="12" class=" p-2 value-background">
                                              <div>{{data.policyInfo[0].fromDate}}</div>
                                          </b-col>
                                          <b-col md="3" sm="12" class=" p-2 value-background-rb " style="background-color: #E0E0E0">
                                              <div class="nino-mtavruli pl-2">ჩათვლით</div>
                                          </b-col>
                                          <b-col md="3" sm="12" class=" p-2 value-background">
                                              <div>{{data.policyInfo[0].toDate}}</div>
                                          </b-col>
                                      </div>
  
                                      <b-col md="12" sm="12" class="mt-2 p-2 content-header1 ">
                                          <div class="col-md-9 col-sm-12 nino-mtavruli pl-2"> შენიშვნებისა და სპეციალური შეთანხმებების ბლოკი</div>
                                      </b-col>
                                      <b-col md="12" sm="12" class="value-background">
                                          {{data.policyInfo[0].addnote}}
                                      </b-col>
                                    </b-row>
                                    <b-row>
                                      <b-col md="12" sm="12" class="p-2 content-header mt-2 ">
                                          <div class="col-md-12 col-sm-12 text-center nino-mtavruli">პოლისის გაცემის საფუძვლები</div>
                                      </b-col>
                                      <b-col md="5" sm="12" class="description p-2 ">ქონების საკრედიტო დაზღვევის პირობები ვერსია 1.20</b-col>
                                      <b-col md="7" sm="12" class="value-background-lrb p-2 ">
                                          <div class="text-center">
                                              <div style="cursor: pointer; color: -webkit-link; " @click="openLink(1)">{{data.policyInfo[0].condition}}</div>
                                          </div>
                                      </b-col>
                                      <b-col md="5" sm="12" class="description p-2 ">გენერალური ხელშეკრულება</b-col>
                                    
                                      <b-col md="7" sm="12" class="value-background-lrb p-2 ">
                                          <div class="text-center">
                                              <div>{{data.policyInfo[0].contnum}}</div>
                                          </div>
                                      </b-col>
                                    </b-row>
                                    <b-row>
                                      <b-col md="12" sm="12" class="border-green p-2 mt-2">
                                          <div class="">
                                              მე დამზღვევი/დაზღვეული, ვაცნობიერებ, რომ პოლისი შეიცავს ჩემს მიერ მოწოდებულ მონაცემებს და ვადასტურებ, რომ ისინი სრულყოფილი
                                              და სწორია. აგრეთვე, ვაცხადებ, რომ დეტალურად განმემარტა სს "არდი დაზღვევა"-ს ქონების საკრედიტო დაზღვევის პირობები, ვეთანხმები და
                                              ვკისრულობ მასში გათვალისწინებული ვალდებულებების სრულად შესრულების ვალდებულებას. ამასთან, თანახმა ვარ, რომ მრავალწლიანი
                                              სესხის შემთხვევაში, პოლისი განახლდეს ავტომატურად, გარდა იმ შემთხვევისა, თუ არ იცვლება(იზრდება) პოლისით გათვალისწინებული
                                              სადაზღვევო გადასახადი (სადაზღვევო პრემია). დაზღვეული/მსესხებელი უფლებამოსილებას ანიჭებს ბანკს, მისი ნებისმიერი ანგარიშიდან,
                                              მისი თანხმობის გარეშე, ჩამოწეროს სადაზღვევო პრემიის თანხა და განახორციელოს ანგარიშსწორება სადაზღვევო კომპანიასთან.
                                              სადაზღვევო კომპანიასთან ანგარისსწორება ხდება ეროვნულ ვალუტაში (ლარში), თუ მსესხებლის ანგარიშზე არსებული თანხა სხვა ვალუტაშია,
                                              ბანკი უფლებამოსილია მსესხებლის ხარჯზე მოახდინოს სავალუტო ერთეულიდან 'მეორეში თანხის კონვერტაცია, ანგარიშიდან თანხის
                                              ჩამოწერის დღისთვის ბანკში მოქმედი კომერციული კურსის შესაბამისად, ასევე ჩამოწეროს კონვერტაციის საკომისიო (არსებობის
                                              შემთხვევაში).
                                          </div>
                                      </b-col>
                                      <b-col md="12" sm="12" class="p-2 content-header mt-2">
                                          <div class="col-md-12 col-sm-12 text-center nino-mtavruli">ხელმოწერები</div>
                                      </b-col>
                                      
                                  
                                  </b-row>
                                <b-row>
                                  <signature :roleid="this.role" class="col-12" />
                                </b-row>
                              </b-col>
                          </div>
                      </div>
                  </div>
                 
                    
                </div>
              </td>
            </tr>
            </tbody>
          
          <tfoot>
            <tr>
                <td>
<!--                  <div class="footer-space">&nbsp;</div>-->
                  <div class="footer-space1"></div>
                </td>
            </tr>
          </tfoot>
            
        </table>


      <div class="page-header">
        <b-col sm="12" md="12" class="p-0 header">
          <div class="d-md-flex pt-md-4 p-0 pb-4">
            <div class="header_logo_property"></div>
            <div class="p-0 sm-text md-text" style="background-color: #E0E0E0">
              <div style="" class="header-text nino-mtavruli">ქონების საკრედიტო დაზღვევის პოლისი</div>
            </div>
          </div>
        </b-col>
      </div>
      <div class="page-footer " >
        <div class="p-0 col-12 footer mt-5">
          <div  class="col-10 offset-sm-0  offset-md-1 offset-lg-1">
            <div class="d-flex justify-content-between mr-4  pb-4 m-lg-n3">
              <img src="../assets/img/ardi-logo.svg" width="140">
              <img src="../assets/img/slogan.svg" width="330" class="pr-3 slogan">
            </div>
          </div>
        </div>
      </div>
      

    </div>
</template>

<script>
import Signature from "@/Procredit/components/Signature";
export default {
  name: "Contract",
  components: {
      Signature
  },
  data() {
      return {
        data: null,
        cont: this.$route.params.cont,
        cust: this.$route.params.cust,
        role: this.$route.params.role,
    }
  },

  mounted() {
    this.$http.get(`/policy/GetProInfo/${this.cont}/${this.cust}`).then(r => {
      this.data = r.data;
      console.log(r.data);
    }).catch((e) => {
      console.log(e)
    })
  },
  methods: {
    openLink: function (url) {
        window.open(url, "_blank");
    }
  }
}
</script>

<style scoped>
@import "~bpg-nino-mtavruli";

.nino-mtavruli {
  font-family: "BPG Nino Mtavruli", sans-serif;
}


.header {
  position: fixed;
  top: 0;
}
.footer {
  position: fixed;
  bottom: 0;
}

/*.page-footer {*/
/*  position: absolute;*/
/*  bottom: 5px;*/
/*}*/

/*.page-header {*/
/*  position: absolute;*/
/*  top: 5px;*/
/*}*/


@media print {
  div {
    break-inside: avoid !important;
  }
  .header-space1, .footer-space1 {
    height: 130px;
  }
  .footer {
    break-inside: avoid !important;
    page-break-after: always;
    page-break-before: always;
  }
}
    .border-green {
        border: 2px solid #00a987 !important;
    }
    .pol-number {
        font-size: 17px;
        font-weight: bold;
    }
    .header-text {
        font-size: 32px;
        font-weight: bold;
        color: #005745;
        height: 71px;
        line-height: 100px;
        text-align: center;
    }
    
    .value-background {
        border-bottom: 1px solid #b0b1b3 !important;
        border-right: 1px solid #b0b1b3 !important;
        border-left: 1px solid #b0b1b3 !important;
        font-size: 14px;
    }
    .value-background-rb {
        border-bottom: 1px solid #b0b1b3 !important;
        border-left: 1px solid #b0b1b3 !important;
        font-size: 14px;
    }
    .value-background-lrb {
        border-bottom: 1px solid #b0b1b3 !important;
        border-right: 1px solid #b0b1b3 !important;
        border-left: 1px solid #b0b1b3 !important;
        font-size: 14px;
    }
    .border-mn {
        border: 1px solid #b0b1b3 !important;
        font-size: 14px;
    }
    .content-header {
        background-color: #005745;
        color: #fff;
        font-size: 14px;
        font-weight: bold;
    }
    .content-header1 {
        background-color: #007961;
        color: #fff;
        font-size: 14px;
        font-weight: bold;
    }

    .description {
        background-color: #007961;
        color: #fff;
        font-size: 14px;
    }

    .description-top {
        background-color: #00A788;
        color: #fff;
    }


    .border-bottom-mn {
        border-bottom: 1px solid #b0b1b3 !important;
       
    }
    .border-right-mn {
        border-right: 1px solid #b0b1b3 !important;
    }



    .payment-block {
        width: 51%;
    }

    table {
        width: 100%;
    }

    .md-text {
        width: 62%
    }
  

    @media (max-width: 500px) {
        .header_logo_property {
            width: 100%;
        }
        .sm-text {
            
            width: 100%
        }
       
        .slogan {
            padding-left: 1.5rem !important;
        }
    }

</style>